// Pilot lockdown flag — set to true to make all node config controls read-only.
// Controls disabled: Enabled checkbox, all select/boolean fields (except Pause After),
// Delete Node button, keyboard delete shortcut.
// To restore full UI control for a release build: set to false.
export const POC_LOCKED = true
